// Filename - pages/AboutUs.js

import React, { useEffect, useState } from "react";
import { Card, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDashboardSuccess,
  paymentAndBalanceGraph,
  usagesGraph,
  disconnectionAndReconnection,
  notificationGraph
} from "./dashboard/dispatch";
import { PieChart } from "@mui/x-charts/PieChart";
import { BarChart } from "@mui/x-charts/BarChart";
import Stack from "@mui/material/Stack";
import { Gauge } from "@mui/x-charts/Gauge";
import {
  GaugeContainer,
  GaugeValueArc,
  GaugeReferenceArc,
  useGaugeState,
  
} from "@mui/x-charts/Gauge";
import { LineChart } from "@mui/x-charts/LineChart";
import { ScatterChart } from "@mui/x-charts/ScatterChart";

const data1 = [
  {
    id: "data-0",
    x1: 329.39,
    x2: 391.29,
    y1: 443.28,
    y2: 153.9,
  },
  {
    id: "data-1",
    x1: 96.94,
    x2: 139.6,
    y1: 110.5,
    y2: 217.8,
  },
  {
    id: "data-2",
    x1: 336.35,
    x2: 282.34,
    y1: 175.23,
    y2: 286.32,
  },
  {
    id: "data-3",
    x1: 159.44,
    x2: 384.85,
    y1: 195.97,
    y2: 325.12,
  },
  {
    id: "data-4",
    x1: 188.86,
    x2: 182.27,
    y1: 351.77,
    y2: 144.58,
  },
  {
    id: "data-5",
    x1: 143.86,
    x2: 360.22,
    y1: 43.253,
    y2: 146.51,
  },
  {
    id: "data-6",
    x1: 202.02,
    x2: 209.5,
    y1: 376.34,
    y2: 309.69,
  },
  {
    id: "data-7",
    x1: 384.41,
    x2: 258.93,
    y1: 31.514,
    y2: 236.38,
  },
  {
    id: "data-8",
    x1: 256.76,
    x2: 70.571,
    y1: 231.31,
    y2: 440.72,
  },
  {
    id: "data-9",
    x1: 143.79,
    x2: 419.02,
    y1: 108.04,
    y2: 20.29,
  },
  {
    id: "data-10",
    x1: 103.48,
    x2: 15.886,
    y1: 321.77,
    y2: 484.17,
  },
  {
    id: "data-11",
    x1: 272.39,
    x2: 189.03,
    y1: 120.18,
    y2: 54.962,
  },
  {
    id: "data-12",
    x1: 23.57,
    x2: 456.4,
    y1: 366.2,
    y2: 418.5,
  },
  {
    id: "data-13",
    x1: 219.73,
    x2: 235.96,
    y1: 451.45,
    y2: 181.32,
  },
  {
    id: "data-14",
    x1: 54.99,
    x2: 434.5,
    y1: 294.8,
    y2: 440.9,
  },
  {
    id: "data-15",
    x1: 134.13,
    x2: 383.8,
    y1: 121.83,
    y2: 273.52,
  },
  {
    id: "data-16",
    x1: 12.7,
    x2: 270.8,
    y1: 287.7,
    y2: 346.7,
  },
  {
    id: "data-17",
    x1: 176.51,
    x2: 119.17,
    y1: 134.06,
    y2: 74.528,
  },
  {
    id: "data-18",
    x1: 65.05,
    x2: 78.93,
    y1: 104.5,
    y2: 150.9,
  },
  {
    id: "data-19",
    x1: 162.25,
    x2: 63.707,
    y1: 413.07,
    y2: 26.483,
  },
  {
    id: "data-20",
    x1: 68.88,
    x2: 150.8,
    y1: 74.68,
    y2: 333.2,
  },
  {
    id: "data-21",
    x1: 95.29,
    x2: 329.1,
    y1: 360.6,
    y2: 422.0,
  },
  {
    id: "data-22",
    x1: 390.62,
    x2: 10.01,
    y1: 330.72,
    y2: 488.06,
  },
];

export const Dashboard = () => {
  // const { data } = useSelector(state => state.loginReducer);
  const data = JSON.parse(localStorage.getItem("USER_DETAILS"));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchDashboardSuccess(data));
    dispatch(paymentAndBalanceGraph(data));
    dispatch(usagesGraph(data));
    dispatch(disconnectionAndReconnection(data))
    dispatch(notificationGraph(data))
  }, []);
  const fallbackDates = [
    new Date("2025-05-22"),
    new Date("2025-05-23"),
    new Date("2025-05-24"),
  ];
  
  const { dashboardReducer } = useSelector((state) => state);

  const paymentAndBalanceGraphData =
    dashboardReducer?.paymentAndBalanceGraph?.pDATASET;

  const totPaymentAmtArray = paymentAndBalanceGraphData?.map(
    (item) => item?.TOT_PAYMENT_AMT
  );
  const walletBalanceArray = paymentAndBalanceGraphData?.map(
    (item) => item?.WALLET_BALANCE
  );


  console.log(paymentAndBalanceGraphData,"paymentAndBalanceGraphData")
 // Separate arrays
 const paymentBalancedateArray = paymentAndBalanceGraphData?.map(item =>
    new Date(item.EVENTDATE).toLocaleDateString('en-IN') // DD/MM/YYYY format
  );

  const finalDatesPaymentBalance =
  paymentBalancedateArray?.length > 0 ? paymentBalancedateArray.map(date => new Date(date)) : fallbackDates;
 
  const usagesGraphData =
  dashboardReducer?.usagesGraph?.pDATASET;

  console.log(usagesGraphData)


  // Separate arrays
const usagesdateArray = usagesGraphData?.map(item =>
    new Date(item.EVENTDATE).toLocaleDateString('en-IN') // DD/MM/YYYY format
  );
  
  const usagesvalueArray = usagesGraphData?.map(item => item.TOT_UNIT);
  

  const fallbackUsages = [0, 0, 0];
  
  const finalDatesUsages =
  usagesdateArray?.length > 0 ? usagesdateArray.map(date => new Date(date)) : fallbackDates;
  
  const finalUsages =
    usagesvalueArray?.length > 0 ? usagesvalueArray : fallbackUsages;

  const disconnectinAndReconnectionData =
  dashboardReducer?.disconnectionAndReconnectionGraph?.pDATASET;


  const disconnectionAndReconnectiondateArray = usagesGraphData?.map(item =>
    new Date(item.EVENTDATE).toLocaleDateString('en-IN') // DD/MM/YYYY format
  );


  const finalDatesDisconnectionAndReconnection =
  disconnectionAndReconnectiondateArray?.length > 0 ? disconnectionAndReconnectiondateArray.map(date => new Date(date)) : fallbackDates;

  // Combine disconnection and reconnection counts
const reDisconCounts = disconnectinAndReconnectionData?.map(item => [item.TOT_DISCON_COUNT, item.TOT_RECON_COUNT]);

  
  
  
  const finalDateDisAndRe =
  reDisconCounts?.length > 0 ? reDisconCounts : fallbackUsages;


  const disconCounts = reDisconCounts?.map(item => item[0]);
  const reconCounts = reDisconCounts?.map(item => item[1]);

  
  const notificationData =
  dashboardReducer?.notificationGraph?.pDATASET;

  console.log(notificationData)

  const notificationDataArray = notificationData?.map(item =>
    new Date(item.EVENTDATE).toLocaleDateString('en-IN') // DD/MM/YYYY format
  );
  const finalDatesNotification =
  notificationDataArray?.length > 0 ? notificationDataArray.map(date => new Date(date)) : fallbackDates;

// Combine disconnection and reconnection counts
const notificationDataValue = notificationData?.map(item => [item. LOWBALANCE_COUNT ,item.HIGH_USAGES, item.RECON_COUNT,item.DISCON_COUNT
]);

const lobalanceCount = notificationDataValue?.map(item => item[0]);
  const highUsages = notificationDataValue?.map(item => item[1]);
  const reconCount = notificationDataValue?.map(item => item[3]);

console.log(notificationDataValue)

  return (
    <Card
      style={{
        height: "94px",
        width: "100%",
        backgroundColor: "#17234D",
        borderRadius: "0px",
      }}
    >
      <Card.Body>
        <Card.Title
          style={{
            color: "#fff",
            fontFamily: "Roboto-Regular",
            fontSize: "25px",
          }}
        >
          Dashboard Tariff
        </Card.Title>
        <Card.Text
          style={{
            color: "#fff",
            fontFamily: "Roboto-Light",
            fontSize: "15px",
          }}
        >
          Dashboard
        </Card.Text>
        <div style={{backgroundColor: "#fff" }}>
          <div className="container">
            <div className="row">
              <div className="col">
                <h6>Payment And Balance</h6>
                <LineChart
                  style={{ padding: "5px" }}
                  xAxis={[
                    {
                      data: finalDatesPaymentBalance ,
                      scaleType: 'time',
                      label: "Total Payment",
                    },
                  ]}
                  series={[
                    {
                      data: walletBalanceArray || [0, 0, 0],
                      label: "Balance",
                    },
                    {
                        data: totPaymentAmtArray || [0, 0, 0],
                        label: "Payment",
                      }
                  ]}
                  height={250}
                />
              </div>
              <div className="col-sm">
              <h6>Usages</h6>
              <LineChart
                xAxis={[
                    {
                    scaleType: 'time',
                    data: finalDatesUsages ,
                    label: "Date",
                    },
                ]}
                series={[
                    {
                    data: finalUsages,
                    label: "Usages",
                    },
                ]}
                height={250}
                style={{ padding: "5px" }}
                />
              </div>
            </div>
          </div>
        </div>

        <div style={{ backgroundColor: "#fff" }}>
          <div className="container">
            <div className="row">
              <div className="col-sm">
              <h6>Disconnections and Re-connections</h6>
                <BarChart
                xAxis={[{ scaleType: 'band', data: finalDatesDisconnectionAndReconnection }]}
                series={[
                    { data: disconCounts || [0,2], label: 'Disconnections' },
                    { data: reconCounts || [0,2], label: 'Reconnections' }
                  ]}
              
                width={500}
                height={250}
                />


              </div>

              <div className="col-sm">
              <h6>Notification</h6>
              <BarChart
                xAxis={[{ scaleType: 'band', data: finalDatesNotification }]}
                series={[
                    { data: lobalanceCount || [0,0,0], label: 'Low-Blance' },
                    { data: highUsages || [0,0,0], label: 'High Usages' },
                    { data: reconCount || [0,0,0], label: 'Reconnections' }
                  ]}
                width={500}
                height={250}
                />
              </div>
              {/* <div className="col-sm">
                            <Card style={{backgroundColor:'#fff',}}>
                                <Card.Body>
                                    <BarChart
                                        series={[
                                            { data: [35, 44, 24, 34] },
                                            { data: [51, 6, 49, 30] },
                                            { data: [15, 25, 30, 50] },
                                            { data: [60, 50, 15, 25] },
                                        ]}
                                        height={290}
                                        xAxis={[{ data: ['Q1', 'Q2', 'Q3', 'Q4'], scaleType: 'band' }]}
                                        margin={{ top: 10, bottom: 30, left: 40, right: 10 }}
                                    />
                                </Card.Body>
                            </Card>
                        </div>
                        */}
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};
